import { useContext } from 'react';
import UserVehicleContext, {
  useVdpPricing
} from '~/context/vdp/UserVehicleContext';
import SptPriceDetailsContext from '../../SptPriceDetailsContext';

export default function useGetCoApplicantLoading(): boolean {
  const { isCoApplicantApplied } = useContext(SptPriceDetailsContext);
  const { vdpPricingInfo } = useContext(UserVehicleContext);
  const {
    financeInfo: {
      coApplicantToggleOn = false,
      coApplicantEligibility: {
        coBorrowerAllowed = false,
        coSignerAllowed = false
      } = {}
    } = {}
  } = useVdpPricing();

  const isToggling =
    (coBorrowerAllowed || coSignerAllowed) &&
    isCoApplicantApplied !== coApplicantToggleOn;

  return isToggling || vdpPricingInfo.isLoading;
}
